


import Directions from '@/components/Directions';
import Star from '@/components/Star';
import TransLink from '@/utils/TransLink';
import React, { useRef } from 'react'

import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    useMap,
    useMapEvents,
} from "react-leaflet";
import { ReactSVG } from 'react-svg';

import arrowsearch from "@/assets/Arrowsearch.svg";
import { useTranslation } from 'react-i18next';
import { ResultItem } from '@/types';


const PopupMap = ({ address }: { address: ResultItem }) => {

    const { t } = useTranslation('glossary')
    const popupRef = useRef(null);
    console.log('address', address);

    return (
        <Popup autoPan={true} ref={popupRef} >
            <div
                className="text-center mt-8 "
                style={{ width: "250px", maxWidth: "250px" }}
            >
                <div className="relative rounded-lg bg-blue-950">
                    <img
                        src={address.image}
                        className="w-full h-auto opacity-80 object-cover mx-auto mb-2 rounded-lg"
                    />
                    <div className="absolute top-2 right-2">
                        <Star item={address} />
                    </div>
                </div>
                <p className="text-lg">{address.name}</p>
                <TransLink
                    title={t("visit_now", { ns: "glossary" })}
                    url={`${address.slug?.prefix}/${address.slug.key}`}
                    className="border mx-auto hover:bg-[#1D24CA] hover:!text-white rounded-full h-10 flex items-center bg-white !text-[#1D26CA] justify-center relative transition"
                >
                    <div className="m-4 font-semibold uppercase">
                        {t("visit_now", { ns: "glossary" })}
                    </div>
                    <span className="absolute right-0">
                        <ReactSVG
                            src={arrowsearch}
                            className="w-10 h-10"
                            beforeInjection={(svg) => {
                                svg.setAttribute(
                                    "style",
                                    "width: 100%; height: 100%;",
                                );
                                svg.querySelectorAll("path").forEach((path) => {
                                    path.setAttribute("fill", "currentColor");
                                });
                            }}
                        />
                    </span>
                </TransLink>
                <Directions
                    iconColor='white'
                    class="w-full !my-0! mt-2 !rounded-full h-10"
                    destinationLat={Number(address.lat)}
                    destinationLng={Number(address.lng)}
                />
            </div>
        </Popup>
    )
}

export default PopupMap